import C from "../../@babel/runtime/helpers/esm/extends2.mjs";
import c from "../../@babel/runtime/helpers/esm/objectSpread22.mjs";
import K from "../../@babel/runtime/helpers/esm/objectWithoutProperties2.mjs";
import * as t from "react";
import j from "../../classnames/index2.mjs";
import F from "../../rc-resize-observer/es/index.mjs";
var H = ["prefixCls", "invalidate", "item", "renderItem", "responsive", "responsiveDisabled", "registerSize", "itemKey", "className", "style", "children", "display", "order", "component"], i = void 0;
function W(e, u) {
  var y = e.prefixCls, a = e.invalidate, m = e.item, d = e.renderItem, o = e.responsive, h = e.responsiveDisabled, b = e.registerSize, E = e.itemKey, N = e.className, g = e.style, x = e.children, z = e.display, I = e.order, l = e.component, w = l === void 0 ? "div" : l, D = K(e, H), r = o && !z;
  function f(s) {
    b(E, s);
  }
  t.useEffect(function() {
    return function() {
      f(null);
    };
  }, []);
  var R = d && m !== i ? d(m) : x, p;
  a || (p = {
    opacity: r ? 0 : 1,
    height: r ? 0 : i,
    overflowY: r ? "hidden" : i,
    order: o ? I : i,
    pointerEvents: r ? "none" : i,
    position: r ? "absolute" : i
  });
  var v = {};
  r && (v["aria-hidden"] = !0);
  var n = /* @__PURE__ */ t.createElement(w, C({
    className: j(!a && y, N),
    style: c(c({}, p), g)
  }, v, D, {
    ref: u
  }), R);
  return o && (n = /* @__PURE__ */ t.createElement(F, {
    onResize: function(s) {
      var S = s.offsetWidth;
      f(S);
    },
    disabled: h
  }, n)), n;
}
var Y = /* @__PURE__ */ t.forwardRef(W);
Y.displayName = "Item";
export {
  Y as default
};
//# sourceMappingURL=Item.mjs.map
